import { Plus, Megaphone, Users, LayoutGrid } from "lucide-react";
import SelectField from "../common/SelectField";
import SearchBar from "../common/SearchBar";
import "../../styles/common.css";
import "../../styles/driverHeader.css"; 

export default function NewsletterHeader({ 
  total, search, onSearch, onAdd, 
  roleFilter, onRoleChange 
}) {
  return (
    <div className="pageHeader">
      <div className="headerTop">
        <div className="pageTitle">
          <div className="titleWithIcon">
            <Megaphone size={24} className="primaryIcon" />
            <h2>Newsletters</h2>
          </div>
          <span className="countBadge">{total} messages</span>
        </div>
        
        <button className="btnPrimary" onClick={onAdd}>
          Diffuser un message
          <Plus size={18} style={{ marginLeft: '8px' }} />
        </button>
      </div>

      <div className="filterActionsRow">
        <div className="selectorsGrid">
          <SelectField
            icon={Users}
            value={roleFilter}
            onChange={onRoleChange}
            options={[
              { label: "Tous les destinataires", value: "all" },
              { label: "Clients uniquement", value: "R02" }, 
              { label: "Chauffeurs uniquement", value: "R03" }, 
            ]}
          />
        </div>

        <div className="searchWrapper">
          <SearchBar
            value={search}
            onChange={onSearch}
            placeholder="Rechercher par titre ou contenu..."
          />
        </div>
      </div>
    </div>
  );
}